<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="page_7"></a>1 <br/>Identity, Community, and Oppression: A Sexual Minority in the Making</h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780226922454_09_pt01.vue?40969d50